import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { OrderDetailsService } from '../../../services/order-details/order-details.service';
import { LocationsService } from 'src/app/core/services/locations/locations.service';
import { Select, Store } from '@ngxs/store';
import { GetPropertylocation, OrderDetails } from '../../../state/order-action';
import { OrderState } from '../../../state/order.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'property-location',
  templateUrl: './property-location.component.html',
  styleUrls: ['./property-location.component.scss'],
})
export class PropertyLocationComponent implements OnInit {
  @Input() orderID: any;
  @Output() errorMsg = new EventEmitter();
  propertyLocationData: any;
  propertyLocationForm: UntypedFormGroup;
  modelImg: boolean;
  button: string;
  confirmMsg: string;
  regions = [];
  cities = [];
  districts = [];
  @Select(OrderState.getPropertyLocation) propertyLocation$: Observable<any>;
  alertmsg: boolean = false;

  constructor(
    private locationsService: LocationsService,
    private store: Store,
    private orderDetailsService: OrderDetailsService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
    this.getPropertyLocation();
    this.getAllRegions();
  }

  createForm() {
    this.propertyLocationForm = this.formBuilder.group({
      address_area: [null, Validators.required],
      address_city: [null, Validators.required],
      district: [null, Validators.required],
      address_street: [null, Validators.required],
      address_building_code: [null],
      landmark: [null],
      short_address: [null, Validators.pattern(/^[A-Z]{4}[0-9]{4}$/)],
      address_unit_code: [null],
      location: [null, Validators.required],
    });
  }

  createFormControls() {
    return this.propertyLocationForm.controls;
  }

  patchValues() {
    this.propertyLocationForm.patchValue({
      address_area: this.propertyLocationData?.address_area?.id,
      address_city: this.propertyLocationData?.address_city?.id,
      district: this.propertyLocationData?.district?.id,
      address_street: this.propertyLocationData?.address_street,
      address_building_code: this.propertyLocationData?.address_building_code,
      landmark: this.propertyLocationData?.landmark,
      short_address: this.propertyLocationData?.short_address,
      address_unit_code: this.propertyLocationData?.address_unit_code,
      location: this.propertyLocationData?.location,
    });

    const regionValue = this.propertyLocationData?.address_area;
    if (regionValue) {
      this.onRegionChange(regionValue?.id, false);
    }
    const cityValue = this.propertyLocationData?.address_city;
    if (cityValue) {
      this.onCityChange(cityValue?.id, false);
    }
  }

  getPropertyLocation() {
    this.store
      .dispatch(new GetPropertylocation({ orderId: +this.orderID }))
      .subscribe((data) => {
        this.propertyLocationData = data.OrderState.propertyLocation;
        if (this.propertyLocationData) {
          this.patchValues();
          if (this.propertyLocationData?.short_address) {
            this.propertyLocationForm.controls['short_address'].setValidators([
              Validators.required,
              Validators.pattern(/^[A-Z]{4}[0-9]{4}$/),
            ]);
            this.propertyLocationForm.controls[
              'short_address'
            ].updateValueAndValidity();
          }
        }
      });
  }

  getAllRegions() {
    this.locationsService.getAllRegions().subscribe((data) => {
      this.regions = data;
    });
  }

  onRegionChange(regionPk: number, resetDependents = true) {
    if (resetDependents) {
      this.propertyLocationForm.patchValue({
        address_city: null,
        district: null,
      });
      this.cities = [];
      this.districts = [];
    }
    if (regionPk) {
      this.locationsService.getCitiesByRegionPK(regionPk).subscribe((data) => {
        this.cities = data;
      });
    }
  }

  onCityChange(cityPk: number, resetDependents = true) {
    if (resetDependents) {
      this.propertyLocationForm.patchValue({ district: null });
      this.districts = [];
    }
    if (cityPk) {
      this.locationsService.getDistrictsByCityPK(cityPk).subscribe((data) => {
        this.districts = data;
        this.updateDistrictValidators();
      });
    } else {
      this.updateDistrictValidators();
    }
  }

  private updateDistrictValidators() {
    const districtControl = this.propertyLocationForm.controls['district'];
    if (this.districts.length === 0) {
      districtControl.clearValidators();
    } else {
      districtControl.setValidators([Validators.required]);
    }
    districtControl.updateValueAndValidity();
  }

  onShortAddressInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const upper = input.value.toUpperCase();
    if (input.value !== upper) {
      this.propertyLocationForm.patchValue({ short_address: upper });
    }
  }

  onShortAddressBlur(event: Event) {
    const input = event.target as HTMLInputElement;
    const trimmedUpperValue = input.value.trim().toUpperCase();
    if (input.value !== trimmedUpperValue) {
      this.propertyLocationForm.patchValue({
        short_address: trimmedUpperValue,
      });
    }
  }

  save(event) {
    if (this.propertyLocationForm.valid) {
      this.alertmsg = false;
      let data = this.propertyLocationForm.value;
      const buttonId = event.buttonId;
      this.orderDetailsService
        .postPropertyLocation(this.orderID, data, buttonId)
        .subscribe(
          (res) => {
            this.showConfirmationModal('تم تحديث البيانات بنجاح.', true);
            this.store
              .dispatch(new OrderDetails({ orderId: +this.orderID }))
              .subscribe((res) => {});
          },
          (error) => {
            this.showConfirmationModal(error.error.error[0], false);
          },
        );
    } else {
      this.alertmsg = true;
    }
  }

  showConfirmationModal(msg, imgSuccess) {
    this.errorMsg.emit({
      message: msg,
      imgSuccess: imgSuccess,
    });
  }

  hideErrorMSG() {
    this.alertmsg = false;
  }
}
